import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { GridItem } from '@bnnvara/grids';
import Link from 'next/link';
import { Heading } from '@bnnvara/typography';
import { track } from '@bnnvara/analytics/src/track';
import { FetchThemeAndArticles } from '../../../api/queries/themeAndArticles.gql';
import ArticleCard from '../../cards/ArticleCard';

const RelatedThemeRecommendation = ({ currentArticle, subThemes }) => {
  if (!subThemes || subThemes.length === 0) {
    return null;
  }

  const trackInfo = {
    category: 'ArticlePage',
    action: 'click',
    label: `relatedThemes-${subThemes[0].slug}`,
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data } = useQuery(FetchThemeAndArticles, {
    variables: {
      paginator: {
        limit: 5,
      },
      themeSlug: subThemes[0].slug,
    },
  });

  let cleanResult = [];
  if (data?.theme?.articles?.edges) {
    cleanResult = data?.theme?.articles?.edges
      .filter((item) => item.id !== currentArticle.id)
      .slice(0, 4);
  }
  const noMinItems = cleanResult.length < 4;

  if (noMinItems) {
    return null;
  }

  return (
    <>
      <GridItem
        columnStartSm="1"
        columnEndSm="span 12"
        columnStartMd="1"
        columnEndMd="span 10"
        columnStartLg="1"
        columnEndLg="11"
      >
        <Heading element="h2" variant="brand">
          Gerelateerd
        </Heading>
      </GridItem>

      {cleanResult.map((relatedArticle) => {
        const url = `${
          relatedArticle.brand.slug !== 'portal'
            ? '/'.concat(relatedArticle.brand.slug)
            : ''
        }/artikelen/${relatedArticle.slug}?theme=${subThemes[0].slug}`;

        return (
          <GridItem
            columnEndSm="span 12"
            columnEndMd="span 6"
            columnEndLg="span 3"
          >
            <Link
              href={url}
              onClick={() => {
                track(trackInfo);
              }}
            >
              <a>
                <ArticleCard
                  id={relatedArticle.id}
                  title={relatedArticle.title}
                  publishDate={relatedArticle.publishDate}
                  commentsEnabled={relatedArticle.commentsEnabled}
                  commentCount={relatedArticle.commentCount}
                  thumbnail={relatedArticle.thumbnail}
                  aria-label={relatedArticle.title}
                  brand={relatedArticle.brand}
                  subTheme={relatedArticle.subThemes[0]}
                  categories={relatedArticle.categories}
                  isThemePage
                />
              </a>
            </Link>
          </GridItem>
        );
      })}
    </>
  );
};

RelatedThemeRecommendation.propTypes = {
  subThemes: PropTypes.string.isRequired,
  currentArticle: PropTypes.node.isRequired,
  slug: PropTypes.string.isRequired,
};

export default RelatedThemeRecommendation;
